import { CmEntity, CmEntityApiData } from 'src/app/shared/models/cm-entity.model';
import { ChannelType } from 'src/app/shared/types/common';

export interface ScheduledMessageApiData extends CmEntityApiData {
  channel: string;
  content: string;
  provider_id: string;
  schedule: string;
  recipients: string;
}

interface ScheduledMessageApiRequestData extends ScheduledMessageApiData {}
export interface ScheduledMessageApiResponseData extends ScheduledMessageApiData {}

export class ScheduledMessage extends CmEntity {
  channel: ChannelType;
  content: string;
  providerId: string;
  recipients: string[];
  schedule: Date;

  constructor(payload: ScheduledMessage | ScheduledMessageApiData) {
    super(payload);

    this.channel = payload.channel as ChannelType;
    this.content = payload.content;
    this.providerId = (payload as ScheduledMessage).providerId || (payload as ScheduledMessageApiData).provider_id;
    this.recipients = payload.recipients.constructor === Array ? payload.recipients : (payload as ScheduledMessageApiData).recipients.split(',');
    this.schedule = new Date(payload.schedule);
  }

  toRequestModel(): ScheduledMessageApiRequestData {
    return {
      ...super.toRequestModel(),
      channel: this.channel,
      content: this.content,
      provider_id: this.providerId,
      schedule: this.schedule.toISOString(),
      recipients: this.recipients.join(','),
    };
  }
}
